import {BrowserRouter,Routes,Route}
from "react-router-dom";

import AuthPage from "./components/login/Auth";
// import PMDashboard from "./components/Dashboard/PMDashboard";
// import AdminDashboard from "./components/Dashboard/AdminDashboard";
import AppRoutes from "./components/Routes";
import ProjectRequest from "./components/Forms/ProjectRequest";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function App(){

return(
  <>
<BrowserRouter>
      <AppRoutes />
    </BrowserRouter>

          <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
    </>
)

}

export default App;